<div class="main-container" (document:click)="handleOutsideClick($event)">
  <input class="input input-text" (ngModelChange)="onInput($event)" [(ngModel)]="hotelName" [placeholder]="placeHolder"
    [disabled]="disabled" (blur)="onFreeTextInput($event)">
  <div class="results-main-container">
    <div *ngIf="predictions?.length > 0">
      <div class="result-item" *ngFor="let prediction of predictions" (click)="selectPrediction(prediction)">
        {{ prediction?.hotelDetails?.hotelName }} ({{prediction?.hotelDetails?.hotelCategory}})
      </div>
    </div>
  </div>
</div>



